/**
 * Adapts Candid write-back history attempts onto the UI row model.
 *
 * @module toCandidWritebackRecord
 */
import { WritebackAttemptRecord } from "../../../../../api/services/candid/candidWritebackHistoryTypes";
import { CandidWritebackRecord } from "../types/candidWriteback";

/**
 * Maps one history-API attempt onto {@link CandidWritebackRecord}.
 *
 * @param attempt - Journal row from write-back history
 * @returns UI write-back row with a string `created_at`
 */
export const toCandidWritebackRecord = (
  attempt: WritebackAttemptRecord,
): CandidWritebackRecord => ({
  ...attempt,
  created_at: attempt.created_at ?? "",
});

/**
 * Maps history attempts onto UI write-back rows.
 *
 * @param attempts - Journal rows from write-back history
 * @returns UI write-back rows in the same order
 */
export const toCandidWritebackRecords = (
  attempts: WritebackAttemptRecord[] | undefined,
): CandidWritebackRecord[] => (attempts ?? []).map(toCandidWritebackRecord);
